interface AccountDetailsConfiguration {
}

$(document).on("turbolinks:load", function () {
    const configElement = document.getElementById("account-details");
    if (configElement) {
        const config : AccountDetailsConfiguration = JSON.parse(configElement.innerHTML);
        const page = new AccountDetailsPage(config);
        $(document).one("turbolinks:before-render", () => page.destroy());
    }
});

export class AccountDetailsPage {
    private $roleSelector: JQuery<HTMLElement>;

    constructor(config: AccountDetailsConfiguration) {
        this.$roleSelector = $("select[name='roleName']")
        this.$roleSelector.on("change", (e) => {
            $(`.role-description[data-role='${this.$roleSelector.val()}']`).collapse('show');
            $(`.role-description:not([data-role='${this.$roleSelector.val()}'])`).collapse('hide');
        })
        const currentRole = this.$roleSelector.val();
        if (currentRole) {
            $(`.role-description[data-role='${currentRole}']`).collapse('show');
        }
    }

    public destroy() {
        this.$roleSelector.off();
    }
}
